import React from 'react'

const BkFlowNavigationBackButton = props =>  {
	const {
		isMobileButton,
		isDisabled,
		toggleEvent,
	} = props

	return  (
		<div
			className={ isMobileButton ?
				"bk-flow-navigation__prev btn btn-text-only mobile start-xs middle-xs col-xs-2"
			:
				"bk-flow-navigation__prev middle-xs"
			}
			disabled={ isDisabled }
			tabIndex={ 0 }
			onClick={ toggleEvent }
		>
			{ process.env.REACT_APP_COMPONENT_NAVIGATION_ARROW_ICON_TYPE === 'caret' ?
				<i className="material-icons" aria-label='Back to homepage'>keyboard_arrow_left</i>
			:
				<i className="material-icons" aria-label='Back to homepage'>arrow_left</i>
			}
		</div>
	)
}

export default BkFlowNavigationBackButton


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationBackButton.js